import ParticipantInfo from './ParticipantInfo';

export const getParticipantInfo = (
    participant,
    participantName,
    optionalAttendees,
    memberConnectionId,
    sendMessage,
    saveAuditTrail,
    telehealthModuleType,
    setParticipants,
) => {

    // Determine if the participant is a phone call attendee
    const isPhoneCall = !participant.identity.startsWith('PCP Office') &&
        participant.identity !== memberConnectionId && participant.identity.includes('-CallSid:');

    return (
        <ParticipantInfo
            key={participant.sid}
            participant={participant}
            sendMessage={sendMessage}
            saveAuditTrail={saveAuditTrail}
            participantName={participantName}
            telehealthModuleType={telehealthModuleType}
            setParticipants={setParticipants}
            isPhoneCall={isPhoneCall}
        />
    );
};
